// 使用常量替代 Mutation 事件類型
// 命名規則: [module]_[mutation name]

/* app */
export const APP_INCREASE_LOADING_COUNTER = 'APP_INCREASE_LOADING_COUNTER'
export const APP_DECREASE_LOADING_COUNTER = 'APP_DECREASE_LOADING_COUNTER'
export const APP_SET_IS_ENABLE_LOADING_MASK = 'APP_SET_IS_ENABLE_LOADING_MASK'

export const APP_SET_MENU_ITEMS = 'APP_SET_MENU_ITEMS'

export const ACTIVITY_SET_EXPORT_FIELDS = 'ACTIVITY_SET_EXPORT_FIELDS'
